//#region Libraries
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import { Column, LinkA } from "components/styles";
import {
	Container,
	TDef,
	DaysCell,
	NameCell,
	LocationCell,
	TeacherNameCell,
	TimeCell,
	ActionsCell,
	LinkAction,
	TDefContent,
} from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import MiniCaption from "components/MiniCaption/MiniCaption";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { eventsSessionStorage } from "services/storage/events";
import { EVENT_STATE_UNPROCESSED_TAB, EVENT_STATE_UNPROCESSED_TAB_BY_TEXT } from "../../utils/constants";
//#endregion

const NoCompletedText = () => {
	return <h4 data-role="no-data">Por completar</h4>;
};
const ListItem = ({
	id, title, standOutEvent,
	duration, time, teacher,
	location, creationOrUpdatedDate,
	isTeacherUser = false, dateEventId,
	enrolled, state, today,
	canTakeAttendance, currentTab, tabData,
	inSyncEventUnprocessed,
	hasAutomaticCertification = false,
}) => {
	const { isPast, isCancelled, isDraft, isUnprocessed } = currentTab.claims;
	const navigate = useNavigate();
	const isDetailBlocked =
		isPast ||
		(
			isUnprocessed &&
			(
				state === EVENT_STATE_UNPROCESSED_TAB.PENDING ||
				inSyncEventUnprocessed
			)
		);
	const canOpenPastEventCertificates =
		isPast && !isTeacherUser && hasAutomaticCertification;
	//#region Functions
	const renderContentDaysCell = () => {
		const { onlyDay, manyDays } = duration;
		return onlyDay ? (
			<h5>{onlyDay.date}</h5>
		) : (
			<>
				<h5>{manyDays.date}</h5>
				<ul>
					{manyDays.days.map((day, idx) => {
						const classList = [];
						day.taken && classList.push("taken");
						return (
							<li
								key={idx}
								className={classList.join(" ")}
							>
								{day.name}
							</li>
						);
					})}
				</ul>
			</>
		);
	};
	const renderContentLocationCell = () => {
		if (!location) return <NoCompletedText />;
		const { zoom, place } = location;
		if (place)
			return (
				<>
					<h4 title={place.campus}>{place.campus}</h4>
					<h5 title={place.address}>{place.address}</h5>
				</>
			);
		const { name, link } = zoom;
		return (
			<>
				<h4>{name}</h4>
				{!link ? (
					<h5>-</h5>
				) : link.startsWith("https://") ? (
					<LinkA
						title={link}
						href={link}
						target="_blank"
					>
						{link}
					</LinkA>
				) : (
					<h5>{link}</h5>
				)}
			</>
		);
	};
	const renderEnrolled = () => {
		const [quantityEnrolled, vacancies] = enrolled
			.split("de")
			.map(item => item.trim());
		return (
			<span data-role="enrolled">
				<strong>{quantityEnrolled}</strong> de {vacancies}
			</span>
		);
	};
	const goToAttendanceView = () => {
		if (isPast) return;
		eventsSessionStorage.eventDataForAttendance.set({
			id,
			dateEventId,
		});
		navigate(ABSOLUTE_PATHS.ATTENDANCE_EVENT);
	};
	const getClassNameNameCell = () => {
		const classList = ["stand-out", "ellipsis"];
		classList.push(standOutEvent ? "yes" : "no");
		return classList.join(" ");
	};
	const goToDetailView = () => {
		eventsSessionStorage.eventId.set(id);
		eventsSessionStorage.isDraftEvent.set(isDraft);
		eventsSessionStorage.isCancelledEvent.set(
			isCancelled
		);
		eventsSessionStorage.openPastEventCertificatesOnly.remove();
	};
	const goToPastEventCertificates = () => {
		eventsSessionStorage.eventId.set(id);
		eventsSessionStorage.isDraftEvent.set(false);
		eventsSessionStorage.isCancelledEvent.set(false);
		eventsSessionStorage.openPastEventCertificatesOnly.set(true);
	};
	//#endregion
	return (
		<Container className={isPast ? "is-past" : ""}>
			<TDef>
				<NameCell
					className={getClassNameNameCell()}
					justify={isDraft && "flex-start"}
				>
					<h3 title={title}>{title}</h3>
					{!isDraft && (
						<div>
							{today && <MiniCaption text="Hoy" />}
							{renderEnrolled()}
							{!isTeacherUser && (
								<span
									data-role="created-date"
									title={creationOrUpdatedDate}
								>
									{creationOrUpdatedDate}
								</span>
							)}
						</div>
					)}
				</NameCell>
			</TDef>
			<TDef>
				<DaysCell>{renderContentDaysCell()}</DaysCell>
			</TDef>
			<TDef>
				<TimeCell>
					<h5>{time}</h5>
				</TimeCell>
			</TDef>
			{!isTeacherUser && (
				<TDef>
					<TeacherNameCell>
						{teacher ? (
							<h5 title={teacher}>{teacher}</h5>
						) : (
							<NoCompletedText />
						)}
					</TeacherNameCell>
				</TDef>
			)}
			<TDef>
				<LocationCell>{renderContentLocationCell()}</LocationCell>
			</TDef>
			{isUnprocessed && (
				<TDef>
					<TDefContent>
						<h5>
							{EVENT_STATE_UNPROCESSED_TAB_BY_TEXT[state] || "-"}
						</h5>
					</TDefContent>
				</TDef>
			)}
			<TDef>
				<ActionsCell minWidth={!isTeacherUser ? (canOpenPastEventCertificates ? "290px" : "200px") : "250px"}>
					<LinkAction
						to={
							isDraft
								? ABSOLUTE_PATHS.UPDATE_EVENT_MANUAL_LOADING
								: ABSOLUTE_PATHS.COMPLETE_DETAIL_EVENT_MANUAL_LOADING
						}
						onClick={goToDetailView}
						className={isDetailBlocked ? "disabled" : ""}>
						Ver detalle
					</LinkAction>
					{canOpenPastEventCertificates && (
						<LinkAction
							to={ABSOLUTE_PATHS.COMPLETE_DETAIL_EVENT_MANUAL_LOADING}
							onClick={goToPastEventCertificates}
						>
							Constancias
						</LinkAction>
					)}
					{!isDraft &&
					isTeacherUser &&
					[tabData.values.GENERAL, tabData.values.PAST].includes(
						currentTab.index
					) &&
					duration.onlyDay ? (
						<Column
							minWidth="unset"
							align="center"
							gap="3px"
						>
							<CustomButton
								text="Asistencia"
								size="small"
								disabled={!canTakeAttendance}
								onClick={goToAttendanceView}/>
						</Column>
					) : (
						isTeacherUser && <div className="offset"></div>
					)}
				</ActionsCell>
			</TDef>
		</Container>
	);
};

export default ListItem;
